import {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import IconPlus from 'assets/icons/plus.svg'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import SpinnerDots from 'components/elements/SpinnerDots'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubEarningsStatement.module.scss'
import ItemDeductionsList from './ItemDeductionsList'
const cx = cn.bind(s)

interface IItemDeductionsBlockProps {
	index: number
}

const ItemDeductionsBlock: FC<IItemDeductionsBlockProps> = ({index}) => {
	const {items, isAutoCalculation, isCalculationLoading, isCalculationValid, addDeductionsItem} =
		usePayStubStore()
	const item = items[index]

	return (
		<div className={cx('deductions__wrapper')}>
			{isCalculationLoading && (
				<div className={cx('spinner')} data-testid="calculationLoading">
					<div className={cx('spinner__wrapper')}>
						<SpinnerDots className={cx('spinner__inner')} />
					</div>
				</div>
			)}
			<div className={cx('deductions', {filter: !isCalculationValid})}>
				<div className={cx('deductions__fields')}>
					<div className={cx('deductions__field')}>
						<span className={cx('label')}>Deductions</span>
					</div>
					<div className={cx('deductions__field')}>
						<span className={cx('label')}>Total</span>
					</div>
					<div className={cx('deductions__field')}>
						<span className={cx('label')}>ytd total</span>
					</div>
				</div>
				<ItemDeductionsList store={item} />

				{index === 0 && (
					<button
						className={cx('btn', 'btn--add')}
						type="button"
						onClick={addDeductionsItem}
						title="Add deductions">
						<IconPlus /> <span>Add deductions</span>
					</button>
				)}
				<div className={cx('deductions--result', 'result')}>
					<div className={cx('deductions__fields', 'result__fields')}>
						<div className={cx('deductions__field', 'result__field')}>
							<span className={cx('label')}>Deduction total</span>
						</div>
						<div className={cx('deductions__field', 'result__field')}>
							<MobxTextInput
								className={cx('ta-right')}
								placeholder="0.00"
								store={items[index]}
								name="deductionTotal"
								type="text"
								isFormatText
								isNumber
								shouldHandleOldValue
								readOnly={isAutoCalculation}
							/>
						</div>
						<div className={cx('deductions__field', 'result__field')}>
							<MobxTextInput
								className={cx('ta-right')}
								placeholder="0.00"
								store={items[index]}
								name="deductionYTDTotal"
								type="text"
								isFormatText
								isNumber
								shouldHandleOldValue
								readOnly={isAutoCalculation}
							/>
						</div>
					</div>
					<div className={cx('deductions__fields', 'result__fields')}>
						<div className={cx('deductions__field', 'result__field')}>
							<span className={cx('label')}>Netpay</span>
						</div>
						<div className={cx('deductions__field', 'result__field')}>
							<MobxTextInput
								className={cx('ta-right')}
								placeholder="0.00"
								store={items[index]}
								name="netpayTotal"
								type="text"
								isFormatText
								isNumber
								shouldHandleOldValue
								readOnly={isAutoCalculation}
							/>
						</div>
						<div className={cx('deductions__field', 'result__field')}>
							<MobxTextInput
								className={cx('ta-right')}
								placeholder="0.00"
								store={items[index]}
								name="netpayYTDTotal"
								type="text"
								isFormatText
								isNumber
								shouldHandleOldValue
								readOnly={isAutoCalculation}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

ItemDeductionsBlock.displayName = 'ItemDeductionsBlock'

export default observer(ItemDeductionsBlock)
